import { Stack, Typography } from '@mui/material';
import React from 'react';

export default function Footer() {
  const date = new Date();
  const year = date.getFullYear();
  return (
    <div className="create-footer">
      <Stack spacing={1}>
        <Typography className="xs:!text-sm sm:!text-lg md:!text-2l">
          {' '}
          Click here to view{' '}
          <a
            href={`${process.env.REACT_APP_BASE_URL_TOS}/assets/PLATFORM_TOS.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}
          >
            Terms of Services
          </a>{' '}
          and{' '}
          <a
            href={`${process.env.REACT_APP_BASE_URL_TOS}/assets/Privacy-policy-Survey.pdf`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline' }}
          >
            Privacy Policy
          </a>
        </Typography>
        <Typography
          variant="h6"
          className="xs:!text-sm sm:!text-lg md:!text-xl"
        >
          {year} © kayawellbeingindex.com All rights reserved.{' '}
        </Typography>
      </Stack>
    </div>
  );
}
